// extracted by mini-css-extract-plugin
export var contentBody = "_7f-9";
export var headerImage = "_7f-2";
export var imageButton = "_7f-7";
export var imageButtonIcon = "_7f-8";
export var imageHeader = "_7f-4";
export var imageHeaderText = "_7f-5";
export var imageOverlay = "_7f-3";
export var imageTitle = "_7f-6";
export var imageWrapper = "_7f-1";
export var taskList = "_7f-a";
export var widget = "_7f-0";